import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import classNames from 'classnames';
import React from 'react';
import { AttentionMessageTypes } from '@eika/attention-message/src';
import AttentionMessage from '@eika/attention-message/src/AttentionMessage';
import { InfoCard } from '@eika/card';
import ExpandListCardElement from '@eika/expand-list-card/lib/ExpandListCardElement';
import { IconTypes } from '@eika/icon';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';
const numberFormat = new Intl.NumberFormat('no-NB', {
  style: 'decimal'
});
const thousandSeparatorIfNumber = value => {
  if (value === undefined) return 'Ikke besvart';
  return Number(value) ? numberFormat.format(Number(value)).toString() : value;
};
const isFormattable = value => {
  return value === 'INTEGER' || value === 'AMOUNT';
};
const SectionSummary = _ref => {
  let {
    sections
  } = _ref;
  // eslint-disable-next-line
  const isSmallScreen = screen.width < 550;
  const summaryLine = (partOne, partTwo, partThree, subanswer) => {
    return /*#__PURE__*/React.createElement("div", {
      key: partOne,
      className: classNames(isSmallScreen ? "summary-small-screen ".concat(subanswer ? 'sub-answer' : '') : 'single-line')
    }, /*#__PURE__*/React.createElement("span", null, partOne), partThree ? /*#__PURE__*/React.createElement("span", null, partTwo, " (", partThree, ")") : /*#__PURE__*/React.createElement("span", null, partTwo));
  };
  const renderHeadline = headline => {
    // eslint-disable-next-line
    return /*#__PURE__*/React.createElement("span", {
      className: isSmallScreen ? '' : 'semibold',
      dangerouslySetInnerHTML: {
        __html: headline
      }
    });
  };
  const renderCompanyActorsSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "N\xF8kkelpersoner for selskapet",
      text: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AttentionMessage, {
        icon: IconTypes.UTROPSTEGN_36,
        type: AttentionMessageTypes.SUCCESS,
        text: "Informasjonen nedenfor er hentet fra offentlige registre. Eventuelle korrigeringer er sendt til bank"
      }), /*#__PURE__*/React.createElement("div", {
        className: "section-child"
      }, section.actors.map(actor => /*#__PURE__*/React.createElement("div", {
        key: actor.maskedPersonId.token + actor.role
      }, summaryLine('Person ', actor.maskedPersonId.value), summaryLine('Navn ', actor.name), summaryLine('Rolle ', actor.role), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null))))),
      id: "N\xF8kkelpersoner-for-selskapet"
    }));
  };
  const renderDynamicSectionSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.sectionHeader
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: section.sectionHeader,
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, section.answers.map(item => /*#__PURE__*/React.createElement("div", {
        key: item.header
      }, item.typeInfo === 'DynamicSectionSummaryYesNoAnswer' && /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'summary-small-screen' : 'single-line')
      }, renderHeadline(item.header), /*#__PURE__*/React.createElement("span", null, item.answer ? 'Ja' : 'Nei')), item.typeInfo === 'DynamicSectionSummarySingleAnswer' && /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'summary-small-screen' : 'single-line')
      }, renderHeadline(item.header), /*#__PURE__*/React.createElement("span", null, item.answer)), item.typeInfo === 'DynamicSectionSummaryTableAnswer' && section.answers.map(obj => /*#__PURE__*/React.createElement("div", {
        key: obj.typeInfo
      }, Object.keys(obj).map(key => summaryLine(key.toString(), obj[key].toString())))), (item.typeInfo === 'DynamicSectionSummaryCheckboxList' || item.typeInfo === 'DynamicSectionSummaryYesNoAnswer' && item.answer) && /*#__PURE__*/React.createElement("div", null, item.typeInfo === 'DynamicSectionSummaryCheckboxList' && /*#__PURE__*/React.createElement("div", {
        key: item.header
      }, /*#__PURE__*/React.createElement("div", {
        className: "semibold sub-answer-question"
      }, item.header), item.answer.map(value => /*#__PURE__*/React.createElement("div", {
        key: value.text + value.selected
      }, summaryLine("".concat(value.text), value.selected ? 'Ja' : 'Nei', undefined, true)))), item.subAnswers.map(subAnswer => /*#__PURE__*/React.createElement("div", {
        key: subAnswer.text
      }, subAnswer.typeInfo === 'DynamicSectionSummarySubAnswerYesNo' && summaryLine(subAnswer.text, subAnswer.answer ? 'Ja' : 'Nei'), subAnswer.typeInfo === 'DynamicSectionSummarySubAnswerSimple' && summaryLine(subAnswer.text, isFormattable(subAnswer.type) ? thousandSeparatorIfNumber(subAnswer.answer) : subAnswer.answer, undefined, true), subAnswer.typeInfo === 'DynamicSectionSummarySubAnswerTable' && subAnswer.typedAnswers.map((list, index) => /*#__PURE__*/React.createElement("div", {
        key: list.toString() + typeof list
      }, list.map(listItem => /*#__PURE__*/React.createElement("div", {
        key: listItem.question + listItem.answer
      }, summaryLine(listItem.question, isFormattable(listItem.type) ? thousandSeparatorIfNumber(listItem.answer) : listItem.answer, undefined, true))), index !== subAnswer.typedAnswers.length - 1 && (!isSmallScreen ? /*#__PURE__*/React.createElement("br", null) : undefined)))))), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null)))),
      id: "GenericSection-".concat(section.sectionHeader)
    }));
  };
  const renderCheckboxSourceOfIncomeSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Inntektskilder",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, summaryLine('Inntektskilde', section.text), section.sources.map(source => /*#__PURE__*/React.createElement("div", {
        key: source.text
      }, summaryLine(source.text, source.selected ? 'Ja' : 'Nei'))), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null)),
      id: "CheckboxInntektskilder"
    }));
  };
  const renderSourceOfIncomeSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Inntektskilder",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, /*#__PURE__*/React.createElement("div", {
        className: "semibold"
      }, section.text), section.sources.length > 0 && section.sources.filter(s => s.selected).map(source => {
        var _source$amount;
        return /*#__PURE__*/React.createElement("div", {
          key: source.text
        }, summaryLine(source.text, "".concat(thousandSeparatorIfNumber((_source$amount = source.amount) === null || _source$amount === void 0 ? void 0 : _source$amount.toString()))), summaryLine('Kommentar', source.comment), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null));
      })),
      id: "Inntektskilder"
    }));
  };
  const renderCompanyInformationSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Selskapsinfo",
      text: /*#__PURE__*/React.createElement("div", {
        className: "section-child"
      }, summaryLine('Selskapsinformasjon ', section.text)),
      id: "Selskapsinfo"
    }));
  };
  const renderCompanyTaxSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Selskapets skatteopplysninger",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, summaryLine('Selskapskatt', section.text)),
      id: "Selskapet-skatteopplysninger"
    }));
  };
  const renderCountrySummary = section => {
    var _section$countryOfBir, _section$countryOfBir2;
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Nasjonalitet og bosted",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, section.countryOfResidence && summaryLine('Bostedsland', section.countryOfResidence.text, section.countryOfResidence.iso2), section.countryOfBirth && summaryLine('Fødeland', (_section$countryOfBir = section.countryOfBirth) === null || _section$countryOfBir === void 0 ? void 0 : _section$countryOfBir.text, (_section$countryOfBir2 = section.countryOfBirth) === null || _section$countryOfBir2 === void 0 ? void 0 : _section$countryOfBir2.iso2), summaryLine('Statsborgerskap', section.citizenship.flatMap(c => "".concat(c.text, " (").concat(c.iso2, ")")).toString())),
      id: "Nasjonalitet-og-bosted"
    }));
  };
  const renderFinancialInstitutionSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Finansinstitusjon opplysninger",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, summaryLine('GIIN', section.giin ? section.giin.number : 'Ingen GIIN'), summaryLine('Skatteklassifisering', section.taxClassification)),
      id: "Finansinstitusjon-opplysninger"
    }));
  };
  const renderPepSummary = section => {
    return /*#__PURE__*/React.createElement("div", {
      key: section.typeInfo
    }, /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Politisk eksponert person (PEP)",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, section.roles.length <= 0 && /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'margin-bottom-small' : undefined)
      }, "Ingen roller"), section.roles.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classNames('semibold', isSmallScreen ? 'margin-bottom-small' : undefined)
      }, "Roller"), section.roles.map(role => /*#__PURE__*/React.createElement("div", {
        key: role.role + role.country.text + role.endDate
      }, summaryLine('Rolle ', role.role), summaryLine('Land ', role.country.text, role.country.iso2), role.endDate && summaryLine('Sluttdato ', "".concat(role.endDate.year, ", ").concat(role.endDate.month)), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null)))), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null), section.relations.length <= 0 && /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'margin-bottom-small' : undefined)
      }, "Ingen relasjoner"), section.relations.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classNames('semibold', isSmallScreen ? 'margin-bottom-small' : undefined)
      }, "Relasjoner"), section.relations.map(relation => /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'sub-answer' : undefined),
        key: relation.relation + relation.name + relation.endDate + relation.role
      }, summaryLine('Rolle ', relation.role), summaryLine('Relasjon ', relation.relation), summaryLine('Navn ', relation.name), summaryLine('Land ', relation.country.text, relation.country.iso2), relation.endDate && summaryLine('Sluttdato ', "".concat(relation.endDate.year, ", ").concat(relation.endDate.month)), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null))))),
      id: "Politisk-eksponert-person-(PEP)"
    }));
  };
  const renderPrivateTaxSummary = section => {
    return /*#__PURE__*/React.createElement(ExpandListCardElement, {
      isActive: false,
      title: "Skatteopplysninger",
      text: /*#__PURE__*/React.createElement("div", {
        className: classNames(isSmallScreen ? 'section-child-small-screen' : 'section-child')
      }, section.taxRelations.length <= 0 && /*#__PURE__*/React.createElement("div", null, "Ingen skatteforhold"), section.taxRelations.length > 0 && section.taxRelations.map(taxRelation => /*#__PURE__*/React.createElement("div", {
        key: (taxRelation.reasonForMissingTaxNumber || taxRelation.taxNumber || taxRelation.toString()) + taxRelation.country
      }, taxRelation.taxNumber && summaryLine('Skattenummer', taxRelation.taxNumber), taxRelation.reasonForMissingTaxNumber && summaryLine('Begrunnelse for manglende skattenummer', taxRelation.reasonForMissingTaxNumber), summaryLine('Land', taxRelation.country.text, taxRelation.country.iso2), isSmallScreen ? undefined : /*#__PURE__*/React.createElement("br", null)))),
      id: "Skatteopplysninger"
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "center-text"
  }, "Oppsummering av kundeerkl\xE6ring"), /*#__PURE__*/React.createElement(AttentionMessage, {
    icon: IconTypes.LYSPAERE_24,
    text: "G\xE5 gjennom de ulike temafeltene s\xE5 du er sikker p\xE5 at informasjonen er rett, f\xF8r du g\xE5r videre",
    type: AttentionMessageTypes.INFO
  }), /*#__PURE__*/React.createElement("br", null), sections.map(section => {
    switch (section.typeInfo) {
      case 'CompanyActorsSummary':
        return renderCompanyActorsSummary(section);
      case 'DynamicSectionSummary':
        return renderDynamicSectionSummary(section);
      case 'CheckboxSourceOfIncomeSummary':
        return renderCheckboxSourceOfIncomeSummary(section);
      case 'SourceOfIncomeSummary':
        return renderSourceOfIncomeSummary(section);
      case 'CompanyInformationSummary':
        return renderCompanyInformationSummary(section);
      case 'CompanyTaxSummary':
        return renderCompanyTaxSummary(section);
      case 'CountrySummary':
        return renderCountrySummary(section);
      case 'FinancialInstitutionSummary':
        return renderFinancialInstitutionSummary(section);
      case 'PepSummary':
        return renderPepSummary(section);
      case 'PrivateTaxSummary':
        return renderPrivateTaxSummary(section);
      default:
        return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  }), /*#__PURE__*/React.createElement(InfoCard, {
    asHeader: true,
    className: "sgw-layout-item sgw-layout-item__full-width",
    img: /*#__PURE__*/React.createElement(RichIcon, {
      type: RichIconTypes.SAMTYKKE
    })
  }, /*#__PURE__*/React.createElement("p", {
    className: "typography-paragraph"
  }, "Ved \xE5 trykke p\xE5 Neste-knappen bekrefter du at all informasjon gitt i denne kundeerkl\xE6ringen er korrekt og fullstendig, og at du forplikter deg til \xE5 informere banken ved endringer.")));
};
export default SectionSummary;